import React from 'react';
import styled from 'styled-components';
import { AddressModel } from '../../entities/address.model';
import AreaFields from './area-fields.component';

interface AddressComponentProps {
    address: AddressModel
    onChange: any
    /** data-testid prefix of the town / district / khoroo selects (default "address") */
    testIdPrefix?: string
}

const FormGroup = styled.div`
    width: 100%;
    margin-top: 20px;
`;

const Label = styled.div`
    font-weight: 700;
    margin-bottom: 10px;
`;

function AddressComponent(props: AddressComponentProps) {

    const handleChange = (e: any) => {
        let address: AddressModel = props.address
        props.onChange({ ...address, [e.target.name]: e.target.value });
      };
    
    return (
        <div className="address-component-container width-100">
            <FormGroup>
                <AreaFields
                    testIdPrefix={props.testIdPrefix || 'address'}
                    areaId={props.address.deliveryAreaId}
                    town={props.address.town || ''}
                    district={props.address.district || ''}
                    onChange={(area) => props.onChange({
                        ...props.address,
                        deliveryAreaId: area.areaId,
                        town: area.town,
                        district: area.district,
                        unit: area.unit,
                    })}
                />
            </FormGroup>
            <FormGroup>
                <Label>Дэлгэрэнгүй</Label>
                <textarea cols={12} rows={4} required name="street" className="width-100" value={props.address.street} onChange={handleChange} />
            </FormGroup>
        </div>
    );
}

export default AddressComponent